<template>
	<div>
		<div v-show="Fpdj">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">发票登记管理</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:inline-block;margin-top:20px">
						<span>项目名称 </span>
						<el-input v-model="condition.projectName" style="margin-left:10px;width:150px"
							placeholder="请输入项目名称">
						</el-input>
					</div>

					<div style="display:inline-block;margin-top:20px">
						<span>服务期 </span>
						<el-input v-model="condition.period_service" style="margin-left:10px;width:150px"
							placeholder="请输入服务期">
						</el-input>
						<el-date-picker v-model="condition.period_service" type="month" placeholder="选择服务期"
							value-format="yyyy-MM" style="margin-left:10px;width:150px">
						</el-date-picker>
					</div>

					<div style="display:inline-block;margin-top:20px">
						<span>金额 </span>
						<el-input v-model="condition.amount_of_money" style="margin-left:10px;width:150px"
							placeholder="请输入金额">
						</el-input>
					</div>

					<div style="display:inline-block;margin-top:20px">
						<span>开票日期 </span>
						<el-date-picker v-model="condition.invoicing_date" type="date" placeholder="选择开票日期">
						</el-date-picker>
					</div>


					<!-- 按钮 -->
					<div style="display:inline-block;margin:20px;">
						<el-button type="goon" @click="Find">查询</el-button>
						<el-button type="goon" @click="Add">新增</el-button>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:2% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="540" @selection-change="handleSelectionChange">
						<!-- <el-table-column type="selection" width="55">
						</el-table-column> -->
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column prop="projectName" align="center" label="项目名称"></el-table-column>
						<el-table-column prop="period_service" align="center" label="服务期"></el-table-column>
						<el-table-column prop="invoice_no" align="center" label="发票号"></el-table-column>
						<el-table-column prop="amount_of_money" align="center" label="金额"></el-table-column>
						<el-table-column prop="invoicing_date" align="center" label="开票日期"></el-table-column>
						<el-table-column prop="registrant_name" align="center" label="登记人"></el-table-column>
						<el-table-column prop="registration_time" align="center" label="登记时间"></el-table-column>
						<el-table-column align="center" label="操作" width="100" fixed="right">
							<template slot-scope="scope">
								<img src="../../../assets/编辑.png" @click="Update(scope.row)">
								<img src="../../../assets/删除.png" @click="Del(scope.row.id)">
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style=" margin-left: 500px;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>
		<el-dialog :title="ruleForm.id == null || ruleForm.id == '' ? '新增' : '修改'" :visible.sync="showDialog"
			width="25%" center="true" :close-on-click-modal="false">
			<div>
				<el-form label-position="right" label-width="80px" :model="formLabelAlign">
					<el-form-item label="项目名称">
						<el-select v-model="ruleForm.project_id" placeholder="请选择项目名称" filterable style="width: 100%;">
							<el-option v-for="item in ProjectList" :key="item.project_id" :label="item.project_name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="服务期">
						<el-date-picker v-model="ruleForm.period_service" type="month" placeholder="选择服务期"
							value-format="yyyy-MM" style="width: 100%;">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="发票号">
						<el-input v-model="ruleForm.invoice_no" placeholder="请输入发票号" style="width: 100%;"></el-input>
					</el-form-item>
					<el-form-item label="金额">
						<el-input v-model="ruleForm.amount_of_money" placeholder="请输入金额" style="width: 100%;">
						</el-input>
					</el-form-item>
					<el-form-item label="开票日期">
						<el-date-picker style="width: 100%;" v-model="ruleForm.invoicing_date" type="date"
							value-format="yyyy-MM-dd" placeholder="选择开票日期">
						</el-date-picker>
					</el-form-item>
					<div style="text-align:center">
						<el-button type="goon" @click="AddSave()"
						v-if="ruleForm.id == null || ruleForm.id == ''">保存</el-button>
						<el-button type="goon" @click="UpdateSave()"
							v-else>修改</el-button>
					</div>
					</el-button>
				</el-form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// import add from './Ygtg_add.vue';
	import axios from 'axios';
	export default {
		components: {
			// add: add,
		},
		data() {
			return {

				total: 0,
				tableData: [],
				staffList: [],
				ruleForm: {
					id: '',
					project_id: '',
					period_service: '',
					amount_of_money: '',
					invoicing_date: '',
					registrant_id: '',
				},
				// 权限
				Fpdj: true,
				showDialog: false,
				ids: [],
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					projectName: '',
					period_service: '',
					amount_of_money: '',
					invoicing_date: '',
				},
				ProjectList: [],

				//回显查询岗位
				project_ide: '',

				//组织架构数据
				organizeList: [],
			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			// 弹窗
			// handleClose() {
			//     this.dialogVisible = false
			// },
			Return() {
				this.showadd = false;
				this.Fpdj = true;
				this.trash();
				this.Find();
			},
			// 新增
			Add() {
				this.ruleForm = {};
				this.getProjectList();
				this.showDialog = true;
			},
			async AddSave() {
				this.ruleForm.registrant_id = this.$globals.user.staff_id;
				var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/add', this.ruleForm);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.ruleForm = {};
						this.showDialog = false;
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			// 操作编辑
			Update(e) {
				this.getProjectList();
				this.ruleForm = e;
				setTimeout(() => {
					this.showDialog = true;
				},200)
			},
			async UpdateSave() {
				var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/update', this.ruleForm);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.ruleForm = {};
						this.showDialog = false;
						this.Find()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			//查询
			async Find() {
				var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getList', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			// 操作删除
			 async Del(e) {
				var record = {
				    ids: [e],
				};
				var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/del', record);
				if (data === "-2000") {
				    this.$message.error("服务器未响应！请稍后重试");
				} else {
				    var code = data.code;
				    var data = data.data;
				    if (code === '200') {
				        this.$message.success(data);
				        this.Find();
				    } else {
				        this.$message.warning(data);
				    }
				}
			},

			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.target_salary = '';
				this.ruleForm.post_name = '';
				this.ruleForm.create_time = '';
				this.ruleForm.transfer_explain = '';
				this.ruleForm.state = '';
				this.ruleForm.staff_id = '';
				this.ruleForm.post_id = '';
				this.ruleForm.staff.staff_card = '';
				this.ruleForm.staff.nowSalary = '';
				this.ruleForm.staff.company_name = '';
				this.ruleForm.staff.modular_name = '';
				this.ruleForm.staff.city_id = '';
				this.ruleForm.staff.project_name = '';
				this.ruleForm.staff_name = '';
				this.ruleForm.staff.staff_name = '';
				this.ruleForm.staff.post_name = '';
				this.ruleForm.organize_temporary_ids = [];
				this.ruleForm.examineDetailsList = [];
			},
			async getProjectList() {
				var res = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getProjectList', {});
				this.ProjectList = res.data
			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.Find();
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// Invoicebill.vue?33e48716